import { gql } from '@apollo/client';

export const GET_NOISE_EVENTS_HISTORY_BASE = gql(`
  query GetNoiseEventsHistoryBase($filter: GetPagedNoiseEventsWithClassificationsFilters!, $paging: PagingInput!) {
    facility {
      noiseEvents (filter: $filter, paging: $paging) {
        previous
        next
        recordCount
        results {
          id
          locationId
          startTime
          endTime
          updatedTime
          leq
          leqMax
          lfMax
          sel
          weighting
          leqMaxTime
        }
      }
    }
  }
`);
